import IcpChart from './IcpChart';
import IcpTable from './IcpTable';

export default {
  'icp-chart': IcpChart,
  'icp-table': IcpTable,
};
